import { JobsApi, LibraryApi } from "@plant/api-client"
import ptCoreClient from "plant-core-client";

export const jobsApi = new JobsApi({}, '', ptCoreClient.$http)
export const libraryApi = new LibraryApi({}, '', ptCoreClient.$http)